// extracted by mini-css-extract-plugin
module.exports = {"modalRoot":"az_EEb","disableScrollBar":"az_FEb","modalTooltip":"az_GEb"};